/**
 * ============================================================================
 * Homepage Route Error UI
 * ============================================================================
 *
 * Purpose: Catch unhandled errors in the homepage route segment.
 * Responsibility: Prevent full-app crash; allow retry without affecting other routes.
 * Risk Level: Low — only shown when homepage server/client tree fails.
 * ============================================================================
 */

"use client";

import { useEffect } from "react";

export default function HomeError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    if (process.env.NODE_ENV !== "production") {
      console.error("[Homepage route error]", error);
    }
  }, [error]);

  return (
    <main className="relative flex min-h-[40vh] flex-col items-center justify-center gap-4 px-4 text-center">
      <h1 className="text-xl font-semibold text-[#1a325d]">
        Something went wrong loading this page.
      </h1>
      <p className="text-sm text-[#686868]">
        Please try again. Other pages on the site are unaffected.
      </p>
      <button
        type="button"
        onClick={reset}
        className="rounded bg-[#1a325d] px-4 py-2 text-sm text-white"
      >
        Try again
      </button>
    </main>
  );
}
